// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"e345cdac","439":"1975a1a1","523":"ebc32918","843":"b90696ff"}[chunkId] + ".chunk.js";
};